interface ScrollCueProps {
  /** Section scroll progress 0..1 — cue fades out as it approaches the end */
  progress: number;
}

/** Desktop-only animated mouse scroll hint pinned to the bottom of a section */
const ScrollCue = ({ progress }: ScrollCueProps) => {
  const visible = progress < 0.9;

  return (
    <div
      className="hidden md:flex absolute bottom-6 left-6 z-20 flex-col items-start gap-2 pointer-events-none transition-opacity duration-500"
      style={{ opacity: visible ? 1 : 0 }}
      aria-hidden="true"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/70">
        scroll
      </span>
      <span className="relative flex h-9 w-5 items-start justify-center rounded-full border border-border/80 bg-background/30 backdrop-blur-sm p-1.5">
        <span className="scroll-cue-dot h-1.5 w-1.5 rounded-full bg-accent" />
      </span>
    </div>
  );
};

export default ScrollCue;
